exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hero-container[data-v-176b04bf] {\n  background-position: center;\n  background-image: var(--background);\n}\n@media screen and (min-width: 375px) {\n.hero-container[data-v-176b04bf] {\n    background-image: var(--background-2x);\n}\n}", ""]);

// exports
